<template>
  <div style="width: calc(100vw - 220px)">
    <hr class="subdivider" />
    <Gantt
      :value="tasks"
      @entityUpdated="entityUpdated"
      @saveChanges="saveChanges"
    ></Gantt>
    <div v-if="isUpdating" class="taskTimeEditor-loader">
      <i class="fas fa-sync fa-spin"></i> ukládám změny...
    </div>
    <div>
      <table v-if="changesTable.length > 0" class="asd-table" style="width: 60%; margin: auto">
        <thead>
          <tr class="table-heading">
            <th>Změněný úkol</th>
            <th>Začátek</th>
            <th>Konec</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="c in changesTable" :key="c.label">
            <td>{{ c.label }}</td>
            <td>{{ c.startStr }}</td>
            <td>{{ c.endStr }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { map, filter, isNumber, orderBy, get, merge, forEach } from 'lodash'
import labels from 'CORE/utils/labels'
import EntityQuery from 'CORE/utils/entity-query'
import Gantt from 'CORE/components/gantt/gantt'
import { DATE_TIME_FORMAT, DATE_FORMAT } from 'CORE/utils/date'
import moment from 'moment'

export default {
    name: 'TaskTree',
    components: {
        Gantt,
    },
    props: {
        projectId: {
            type: String,
            required: true,
            default: _ => null,
        },
    },
    data() {
        return {
            isUpdating: false,
            changes: {},
        }
    },
    computed: {
        tasks() {
            const tasks = filter(this.$store.getters.tasksByProjectId(this.projectId), t => {
                const q = new EntityQuery(this.$store)
                const startDate = q.singleValueByTag(t, 'startTime')
                const endDate = q.singleValueByTag(t, 'endTime')
                return isNumber(startDate) && isNumber(endDate)
            })
            return orderBy(map(tasks, t => {
                const q = new EntityQuery(this.$store)
                const startType = this.$store.getters.propertyTypeByKey(q.onePropertyByTag(t, 'startTime').key).type
                const endType = this.$store.getters.propertyTypeByKey(q.onePropertyByTag(t, 'endTime').key).type
                const startDate = q.singleValueByTag(t, 'startTime')
                const endDate = q.singleValueByTag(t, 'endTime')
                // const parentId = _.head(q.singleValueByTag(t, 'parentTask'))
                const color = q.singleValueByTag(t, 'entityColor')
                const dependentOn = q.singleValueByTag(t, 'dependentOn')

                return {
                    id: t.id,
                    label: labels.task(t),
                    startTime: get(this.changes, `${t.id}.startTime`, startDate),
                    endTime: get(this.changes, `${t.id}.endTime`, endDate),
                    color,
                    dependOn: dependentOn,
                    startType,
                    endType,
                }
            }), ['startTime', 'asc'])
        },
        changesTable() {
            return map(this.changes, (c, id) => {
                console.info(c, id)
                const task = this.$store.getters.taskById(id)

                let startStr = 'bez změny'
                if (get(c, 'startTime')) {
                    startStr = moment(get(c, 'startTime'), 'X').format(DATE_TIME_FORMAT)
                }

                let endStr = 'bez změny'
                if (get(c, 'endTime')) {
                    endStr = moment(get(c, 'endTime'), 'X').format(DATE_TIME_FORMAT)
                }

                return {
                    label: labels.task(task),
                    startStr,
                    endStr,
                }
            })
        },
    },
    methods: {
        async entityUpdated(change) {
            const q = new EntityQuery(this.$store)
            const entity = this.$store.getters.taskById(change.id)

            const str = q.onePropertyByTag(entity, 'startTime')
            if (str.singleValue !== change.startTime) {
                console.info('start change', change.id)
                this.$set(this.changes, change.id, merge(get(this.changes, change.id, {}), { startTime: change.startTime }))
            }

            const etr = q.onePropertyByTag(entity, 'endTime')
            if (etr.singleValue !== change.endTime) {
                console.info('end change', change.id)
                this.$set(this.changes, change.id, merge(get(this.changes, change.id, {}), { endTime: change.endTime }))
            }

            this.$forceUpdate()

            if (!get(this.$store.getters.settings, 'gui.gantt.manualSave', false)) {
                await this.saveChanges()
            }
        },
        async saveChanges() {
            const q = new EntityQuery(this.$store)
            forEach(this.changes, async (change, entityId) => {
                try {
                    this.isUpdating = true
                    const entity = this.$store.getters.taskById(entityId)
                    const str = q.onePropertyByTag(entity, 'startTime')
                    if (get(change, 'startTime', false)) {
                        str.singleValue = change.startTime
                    }
                    const etr = q.onePropertyByTag(entity, 'endTime')
                    if (get(change, 'endTime', false)) {
                        etr.singleValue = change.endTime
                    }
                    await this.$store.dispatch('updateTask', entity)
                } finally {
                    this.isUpdating = false
                }
            })
            this.changes = {}
        },
    },

}
</script>

<style scoped lang="scss">
.taskTimeEditor {
    display: flex;
    justify-content: space-evenly;
    &-section {
        display: flex;
        flex-direction: column;
        padding: 10px;
        border: 1px solid rgb(238, 238, 238);
        h6 {
            text-align: center;
        }
    }
    &-loader {
        z-index: 999;
        height: 100px;
        background: rgba(255, 255, 255, 0.8);
        width: calc(100vw - 220px);
        position: absolute;
        transform: translateY(-100px);
        text-align: center;
        line-height: 100px;
        color: firebrick;
        font-size: 2rem;
    }
    &-controls {
        display: flex;
        align-content: space-around;
        flex-direction: column;
        &>div {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            &>button {
                margin: 3px;
            }
        }
    }
}
hr.subdivider {
    color: gray;
    border-top: 1px silver dashed;
    margin: 15px 10%;
}
.gantt-controls {
    display: flex;
    margin: 5px;
    &> * {
        margin-right: 5px;
    }
}
</style>

